<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        btitle="Gemport Config"
        style="height: 410px"
      >
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="isShowAddTable = true"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllGem"
                />
                <label for="idSelectAllGem"></label>
              </th>
              <th v-for="(value, key) in title" :key="key" :title="value">
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in gemTable"
              :key="row.profileid"
              :class="{ 'true:': true }"
              @click="changeSelect(row)"
            >
              <td width="40px">
                <div @click.stop="" v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectgem' + index"
                  />
                  <label :for="'idRowSelectgem' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.gemPort }}</div>
              </td>
              <td>
                <div>{{ row.tcontId }}</div>
              </td>
              <td>
                <div>{{ row.vlanProfileId }}</div>
              </td>
              <td>
                <div>{{ row.usProfileId }}</div>
              </td>
              <td>
                <div>{{ row.dsProfileId }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Gemport Edit'"
            @close="isShowAddTable = false"
            style="min-height: 410px"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="gemPort">{{
                  title.gemPort
                }}</label>
                <div class="col-sm-5" :class="{ 'has-error': input_para_check(1)}">
                  <input
                    type="text"
                    class="form-control"
                    id="gemPort"
                    :disabled="isEditClik"
                    v-model="gemForm.gemPort"
                    autocomplete="off"
                    placeholder="INTEGER<1-1024>"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: input_para_check(1) ? 'block' : 'none',
                    }"
                    >{{ input_para_check(1) }}
                  </small>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="tcontgem">{{
                  title.tcontId
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="tcontgem"
                    v-model="gemForm.tcontId"
                  >
                    <option value="" disabled selected style="display: none">
                      please choose..
                    </option>
                    <option
                      v-for="(tcont, index) in tcontTable"
                      :key="index"
                      :value="tcont.tcontId"
                    >
                      {{ tcont.tcontId }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="vlangem">{{
                  title.vlanProfileId
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="vlangem"
                    v-model="gemForm.vlanProfileId"
                  >
                    <option value="">
                      None
                    </option>
                    <option
                      v-for="(vlan, index) in vlanTable"
                      :key="index"
                      :value="vlan.profileId"
                    >
                      {{ vlan.profileId + ":" + vlan.profileName}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="usgem">{{
                  title.usProfileId
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="usgem"
                    v-model="gemForm.usProfileId"
                  >
                    <option value="" >
                      None
                    </option>
                    <option
                      v-for="(us, index) in usTable"
                      :key="index"
                      :value="us.profileId"
                    >
                      {{ us.profileId + ":" + us.profileName }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="dsgem">{{
                  title.dsProfileId
                }}</label>
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="dsgem"
                    v-model="gemForm.dsProfileId"
                  >
                    <option value="">
                      None
                    </option>
                    <option
                      v-for="(ds, index) in dsTable"
                      :key="index"
                      :value="ds.profileId"
                    >
                      {{ ds.profileId + ":" + ds.profileName }}
                    </option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"

export default {
  name: "profileLineGem",
  components: {
    BlockCntr,
    DialogBox,
    InfoBox,
  },

  props: ["profileId"],

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      iBox: {},
      isSelectAll: false,
      select: [],

      gemForm: {
        gemPort: "",
        tcontId: "",
        vlanProfileId: "",
        usProfileId: "",
        dsProfileId: "",
      },

      gemTable: [],
      tcontTable: [],
      vlanTable: [],
      usTable: [],
      dsTable: [],
    }
  },

  created() {
    this.loadGemportInfo()
    this.loadvlanProfile()
    this.loadtcontInfo()
    this.loadUsProfile()
    this.loadDsProfile()
  },

  methods: {
    loadGemportInfo() {
      get("profilegemport?profileId=" + this.profileId)
        .then((res) => {
          this.title = res.data.title
          this.gemTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadvlanProfile() {
      get("profilevlanpri")
        .then((res) => {
          this.vlanTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadtcontInfo() {
      get("profiletcont?profileId=" + this.profileId)
        .then((res) => {
          this.tcontTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadUsProfile() {
      get("profileus")
        .then((res) => {
          this.usTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadDsProfile() {
      get("profileds")
        .then((res) => {
          this.dsTable = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        gemPort: "",
        tcontId: "",
        vlanProfileId: "",
        usProfileId: "",
        dsProfileId: "",
      }

      this.gemForm = dbaformTmp
    },

    profileSortFun(a, b) {
      return Number(a.gemPort) - Number(b.gemPort)
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.profileId),
        gemPort: Number(this.gemForm.gemPort),
        tcontId: Number(this.gemForm.tcontId),
        vlanProfileId: Number(this.gemForm.vlanProfileId),
        usProfileId: Number(this.gemForm.usProfileId),
        dsProfileId: Number(this.gemForm.dsProfileId),
        operate: 1,
      }

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      if (this.gemForm.vlanProfileId == "") newProfile.vlanProfileId = -1
      if (this.gemForm.usProfileId == "") newProfile.usProfileId = -1
      if (this.gemForm.dsProfileId == "") newProfile.dsProfileId = -1

      if (!this.isEditClik) {
        for (let i = 0; i < this.gemTable.length; i++) {
          if (this.gemTable[i].gemPort == newProfile.gemPort) {
            this.showAlertBox(
              "warn",
              "Message",
              "this gemPort id has been existed,please choose a new one"
            )
            return
          }
        }
      }

      post("profilegemport", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadGemportInfo()
            /*if (newProfile.vlanProfileId == -1) newProfile.vlanProfileId = ""
            if (newProfile.usProfileId == -1) newProfile.usProfileId = ""
            if (newProfile.dsProfileId == -1) newProfile.dsProfileId = ""
            if (this.isEditClik) 
            {
              let index = this.select[0]
              this.gemTable[index] = newProfile
            }else {
              this.gemTable.push(newProfile)
              this.gemTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.gemTable.length; i++) {
        if (this.gemTable[i].selected) {
          this.gemForm.gemPort = this.gemTable[i].gemPort
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 0,
        gemPort: 1,
        operate: 2,
      }

      for (i = 0; i < this.gemTable.length; i++) {
        if (this.gemTable[i].selected) {
          newProfile.profileId = Number(this.profileId)
          newProfile.gemPort = Number(this.gemTable[i].gemPort)
          del.push(post("profilegemport", newProfile))
          id.push(this.gemTable[i].gemPort)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.gemTable.length; i++) {
                if (this.gemTable[i].gemPort == id[index]) {
                  this.gemTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.gemTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.gemTable[i], "selected", true)
        } else {
          this.$set(this.gemTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.gemForm.gemPort != "")
        {
            let gemPort = Number(this.gemForm.gemPort)
            if(!isNaN(gemPort))
            {
                if(gemPort < 1 || gemPort > 1024)
                return "gemPort id must be in range 1-1024"
            }
            else
              return "gemPort id must be in range 1-1024"
        }
      }
      return null
    }
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>
